export class Initiative{
    id: number;
    name: string;
    code: string;
}